import { render, staticRenderFns } from "./userDetail.vue?vue&type=template&id=293b3143&scoped=true&"
import script from "./userDetail.vue?vue&type=script&lang=ts&"
export * from "./userDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293b3143",
  null
  
)

export default component.exports